import styled from 'styled-components';
import { getStatusColor } from '../../../utils';

const handleRadius = ({ direction }) => {
  if (direction === 'ltr') {
    return '0 10px 10px 0';
  } else {
    return '10px 0 0 10px';
  }
};

export default styled.div`
  width: 12px;
  border-radius: ${handleRadius};
  background-color: ${(props) => getStatusColor(props.status)};
  display: flex;
  align-self: stretch;
`;
